module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-koh@2x.15d606dd.jpg";